{
  "fr": {
    "issue_list": {
      "actions": {
        "add_units": "Unités",
        "all_units_assigned": "Toutes les unités affectées",
        "change_responsible": "Changement responsable",
        "check": "Vérifier",
        "create_issue_lists": "Créer liste de points | Créer listes de points",
        "delete": "Supprimer",
        "delete_count": "Vous êtes sur le point de supprimer les points pour {count} unités. Êtes-vous sûr? | Vous êtes sur le point de supprimer les points pour {count} unités. Êtes-vous sûr?",
        "delete_issue_lists": "Supprimer les points",
        "edit": "Modifier",
        "edit_issue_list": "Modifier le type de liste de points",
        "export": "Exportation",
        "generatePDF": "Générer un PDF",
        "go_to_summary": "Aller au résumé",
        "new": "Point",
        "new_customer": "Signaler un défaut",
        "new_issue_list": "Liste de points",
        "selectAll": "Sélectionnez toutes les listes {total}",
        "unSelectAll": "Effacer la sélection",
        "update": "Mettre à jour"
      },
      "attributes": {
        "date": "Date de début",
        "description": "Description",
        "name": "Nom"
      },
      "labels": {
        "aftercare_conversations": "Conversations de suivi",
        "aftercare_conversations_go_to_settings": "Aller aux paramètres",
        "aftercare_conversations_not_enabled": "Les conversations dans le cadre du suivi ne sont pas encore activées. Vous pouvez les activer dans les paramètres de votre entreprise.",
        "aftercare_conversations_toggle": "Permettre des conversations dans le cadre de la postcure",
        "assign_to_list": "Assigner à la liste",
        "collapse_all": "Réduire",
        "completed_header": "{completed_count} sur {issues_count} points terminés",
        "customer": "Client",
        "date": "Date de début (facultatif)",
        "delete_explanation": "Tous les points ainsi que leurs images et documents supprimés définitivement de la plate-forme.",
        "description_title": "Ajouter une description",
        "deselect_all": "Désélectionner tout",
        "edit_multiple": "Modifier {count} listes de remarques",
        "hide_count": "Dépublier les numéros pour 1 unité | Annuler la publication des numéros pour {count} unités",
        "hide_count_SUP": "Dépublier les numéros",
        "issue_list": "Liste de points",
        "issue_lists": "Listes de points",
        "issue_lists_all_projects": "Suivi de tous les projets",
        "no_issues_to_export": "Aucun point à exporter",
        "no_lists_completed": "Aucune liste terminée",
        "open_all": "Ouvrir",
        "partners": "Partenaires",
        "pdf_generated_successfully": "PDF généré avec succès",
        "process_issues": "Attribuer à la liste",
        "project_units_total": "{project_name} a {units_count_max} unités au total",
        "publish_now": "Publier maintenant?",
        "published_count": "Publier les numéros pour 1 unité | Publier les numéros pour {count} unités",
        "published_count_SUP": "Publier les numéros",
        "save_explainer": "Rendre les (futurs) points visibles pour vos clients? Ou enregistrer et publier plus tard?",
        "selectOne": "Sélectionnez au moins 1 liste",
        "select_all": "Tout sélectionner",
        "selected": "{selected} liste sélectionnée. | {selected} listes sélectionnées",
        "status": "status",
        "step_1_info": "Ex. livraison préliminaire ou finale, points pour la cuisine ou les salles de bain,...",
        "step_1_title": "Quel type de liste de points voulez-vous créer?",
        "step_2_subtitle": "Sélectionnez votre projet pour inclure toutes vos unités à la fois. Vous pourrez toujours ajouter d'autres unités plus tard.",
        "step_2_title": "Pour quelles unités voulez-vous enregistrer les points?",
        "tab_issue_list_documents": "Documents",
        "tab_issue_list_issues": "Points",
        "tab_issue_list_issues_customer": "Défauts",
        "tab_issue_list_tickets": "Conversations",
        "tab_issues": "Tous les points",
        "tab_units": "Unités",
        "totalSelected": "Toutes les listes {total} sont sélectionnées",
        "you_have_customer_issues": "Vous avez 1 point d'un client non traité | Vous avez {number} points des clients non traités"
      },
      "navigation": {
        "back_to_issue_lists": "Retour à listes de points"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Suivi des remarques signalés",
            "title": "Tous vos remarques seront affichés ici"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Créer des points pour les unités attachées à la liste",
            "title": "Créez votre première liste de points"
          }
        },
        "partners": {
          "subtitle": "Vous serez averti lorsque de nouveaux points auront été créés",
          "title": "Aucun point ne vous a encore été attribué"
        }
      },
      "validation": {
        "name_already_taken": "Le nom est déjà pris pour ce projet.",
        "need_name": "Le nom est requis"
      }
    }
  }
}